/**
 * Curtain Length Selector - JavaScript for handling length changes and redirects
 * Redirects to sibling product when length is changed
 */

class CurtainLengthSelector {
  constructor() {
    this.select = document.getElementById('curtain-length-select');
    this.siblingsData = this.getSiblingsData();
    
    if (this.select && this.siblingsData) {
      this.init();
    }
  }

  init() {
    // Add event listener for length changes
    this.select.addEventListener('change', this.handleLengthChange.bind(this));
  }

  /**
   * Get siblings data from JSON script tag
   * @returns {Object|null} Siblings data or null if not found
   */
  getSiblingsData() {
    const dataScript = document.getElementById('curtain-siblings-data');
    if (!dataScript) {
      console.warn('Curtain siblings data not found');
      return null;
    }

    try {
      return JSON.parse(dataScript.textContent);
    } catch (error) {
      console.error('Error parsing curtain siblings data:', error);
      return null;
    }
  }

  /**
   * Handle length change and redirect to sibling product
   * @param {Event} event - Change event
   */
  handleLengthChange(event) {
    const selectedLength = event.target.value;
    const currentLength = this.siblingsData.currentLength;
    
    // Don't redirect if the same length is selected
    if (selectedLength === currentLength) {
      return;
    }

    // Find sibling product with the selected length
    const siblingProduct = this.siblingsData.siblings.find(sibling => 
      sibling.length === selectedLength
    );

    if (siblingProduct) {
      // Redirect to sibling product
      window.location.href = siblingProduct.url;
    } else {
      console.warn(`No sibling product found for length: ${selectedLength}`);
      
      // Show user feedback
      this.showNotification(`No product available for ${selectedLength}" length`, 'warning');
    }
  }

  /**
   * Show notification to user
   * @param {string} message - Notification message
   * @param {string} type - Notification type (success, warning, error)
   */
  showNotification(message, type = 'info') {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `curtain-length-notification curtain-length-notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'warning' ? '#f59e0b' : type === 'error' ? '#ef4444' : '#3b82f6'};
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      z-index: 1000;
      font-family: var(--font-helvetica-neue), sans-serif;
      font-size: 14px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      animation: slideIn 0.3s ease-out;
    `;

    // Add animation styles
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
    `;
    document.head.appendChild(style);

    // Add to page
    document.body.appendChild(notification);

    // Remove after 3 seconds
    setTimeout(() => {
      notification.remove();
      style.remove();
    }, 3000);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CurtainLengthSelector();
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CurtainLengthSelector();
  });
} else {
  new CurtainLengthSelector();
}
